import React from 'react';
import { AutocompleteInput } from './AutocompleteInput';
import { SuggestionsList } from './SuggestionsList';
import { useAutocomplete } from './useAutocomplete';

interface AutocompleteProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  error?: string;
  required?: boolean;
  tooltip?: string;
  placeholder?: string;
}

export const Autocomplete: React.FC<AutocompleteProps> = ({
  label,
  value,
  onChange,
  options,
  error,
  required,
  tooltip,
  placeholder
}) => {
  const {
    isOpen,
    suggestions,
    wrapperRef,
    setIsOpen,
    handleInputChange,
    handleSuggestionSelect
  } = useAutocomplete(value, options, onChange);

  return (
    <div className="relative" ref={wrapperRef}>
      <AutocompleteInput
        value={value}
        onChange={handleInputChange}
        onFocus={() => setIsOpen(true)}
        label={label}
        error={error}
        required={required}
        tooltip={tooltip}
        placeholder={placeholder}
      />
      {isOpen && <SuggestionsList suggestions={suggestions} onSelect={handleSuggestionSelect} />}
    </div>
  );
};